<app-filter-panel [numberOfResults]="numberOfResults" [activeFilterCount]="activeFilterCount"
  (apply)="onApply()" (cancel)="onCancel()">

  <!-- Asset Types -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
    </div>
    <div class="col-md-12 d-flex flex-column justify-content-start custom-left-padding pe-3 pb-3">
      <div class="row-md-12 switch-container d-flex pb-3" *ngFor="let item of assetTypes">
        <div class="col-auto d-flex align-items-center">
          <label class="switch" [for]="'checkbox-' + item.name">
            <input type="checkbox" [id]="'checkbox-' + item.name"
              [checked]="isIn(draftAssetTypes, item.value!)"
              (change)="draftAssetTypes = toggleGuid(draftAssetTypes, item)" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col ps-3 d-flex justify-content-start">
          <label [for]="'checkbox-' + item.name">{{ item.name }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Area -->
  <div class="row g-0 m-0 borderb">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "DEVICESETUP_AREA" | translate }}</span>
    </div>
    <div class="col-md-12">
      <app-multi-select-dropdown-search
        [selected]="draftAreas"
        [fetchItems]="fetchAreas"
        placeholder="AREA_SEARCHBY"
        (listEmitted)="onAreaListReceived($event)">
      </app-multi-select-dropdown-search>
    </div>
  </div>

  <!-- Region -->
  <div class="row g-0 m-0">
    <div class="col-md-12 d-flex justify-content-start custom-left-padding pt-3 pe-3 pb-3">
      <span class="item-name">{{ "REGION" | translate }}</span>
    </div>
    <div class="col-md-12">
      <app-multi-select-dropdown-search
        [selected]="draftRegions"
        [fetchItems]="fetchRegions"
        placeholder="REGION_SEARCHBY"
        (listEmitted)="onRegionListReceived($event)">
      </app-multi-select-dropdown-search>
    </div>
  </div>

</app-filter-panel>
